import { F as Flag, d as defineCustomElement$1 } from './flag.js';
var SkpFlag = Flag;
var defineCustomElement = defineCustomElement$1;
export { SkpFlag, defineCustomElement };